module.exports = __webpack_public_path__ + "media/images/sr_register02-bf12707c.svg";